export const TRANSFER_TYPE_MAPPING = {
    'GT14-WT': 'Ohne Transfer',
    'GT14-TR': 'Mit Transfer',
    'GT14-HC': 'Mit Mietwagen'
}
